import { Component, OnInit } from '@angular/core';

 /**
  * Footer Component.
  */
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  standalone: false
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
